export const PROJECTS = [
  {
    id: "hushnet",
    name: "HushNet",
    year: "2024",
    ongoing: true,
    primary: "Rust",
    tags: ["X3DH", "Double Ratchet", "Cryptography"],
    github: "https://github.com/adamlbs",
    featured: true,
    color: "#7c1d35",
    img: "/hushnet.png",
    imgGradient:
      "linear-gradient(135deg, #1a0810 0%, #5c1428 50%, #7c1d35 100%)",
    desc: {
      en: "End-to-end encrypted messaging protocol built from scratch in Rust. Implements X3DH key exchange and the Double Ratchet algorithm : the same cryptographic primitives behind Signal.",
      fr: "Protocole de messagerie chiffrée de bout en bout développé en Rust. Implémente l'échange de clés X3DH et l'algorithme Double Ratchet : les mêmes primitives cryptographiques que Signal.",
    },
  },
  {
    id: "dohexftlk",
    name: "DoHExfTlk",
    year: "2024",
    primary: "Python",
    img: "/mermaid-diagram-2026-04-26T13-28-27.png",
    tags: ["DNS", "Machine Learning", "Security"],
    github: "https://github.com/adamlbs/DoHExfTlk",
    featured: true,
    color: "#1e3d7c",
    imgGradient:
      "linear-gradient(135deg, #080f22 0%, #0f2050 50%, #1e3d7c 100%)",
    desc: {
      en: "Open-source toolkit to generate, intercept and analyze DNS-over-HTTPS exfiltration traffic. Built for my MSc dissertation to benchmark ML vs threshold-based detection under adversarial conditions.",
      fr: "Toolkit open-source pour générer, intercepter et analyser le trafic d'exfiltration DNS-over-HTTPS. Conçu pour mon mémoire de master : comparaison ML vs détection par seuils en conditions adversariales.",
    },
  },
  {
    id: "libropen",
    name: "LibrOpen",
    year: "2024",
    primary: "TypeScript",
    website: "https://libropen.com",
    img: "/libropen.ico",
    tags: ["AdonisJS", "Next.js", "Docker", "GitHub Actions"],
    color: "#1e5c32",
    imgGradient:
      "linear-gradient(135deg, #081510 0%, #103822 50%, #1e5c32 100%)",
    desc: {
      en: "Open-source developer marketplace. GitHub Actions CI/CD with self-hosted runners, containerized AdonisJS/Node.js services, Next.js frontend, and security-by-design: OAuth2, rate limiting, XSS/CSRF/CORS protections.",
      fr: "Marketplace pour développeurs open-source. CI/CD GitHub Actions avec runners self-hosted, services AdonisJS/Node.js conteneurisés, frontend Next.js, et sécurité dès la conception : OAuth2, rate limiting, protections XSS/CSRF/CORS.",
    },
  },
  {
    id: "previplus",
    name: "Prévi+",
    year: "2022",
    ongoing: true,
    primary: "Flutter",
    website: "https://previplus.fr",
    tags: ["Firebase", "Dart", "Prometheus"],
    stat: { en: "~170k users", fr: "~170k utilisateurs" },
    featured: true,
    color: "#1e4a8e",
    img: "/previplus.png",
    imgGradient:
      "linear-gradient(135deg, #080e22 0%, #102a5a 50%, #1e4a8e 100%)",
    desc: {
      en: "Hyperlocal weather platform for the Bouches-du-Rhône. Infrastructure scaled for traffic surges with Prometheus/Grafana monitoring and Cloudflare CDN.",
      fr: "Plateforme météo hyperlocale pour les Bouches-du-Rhône. Infrastructure dimensionnée pour les pics de trafic, monitoring Prometheus/Grafana et CDN Cloudflare.",
    },
  },
  {
    id: "firechaser",
    name: "FireChaser",
    year: "2022",
    ongoing: true,
    primary: "Flutter",
    website: "https://app.firechaser.fr",
    tags: ["Firebase", "Dart"],
    stat: {
      en: "~25k users · national TV",
      fr: "~25k utilisateurs · télé nationale",
    },
    featured: true,
    color: "#9c2800",
    img: "/firechaser.png",
    imgGradient:
      "linear-gradient(135deg, #180400 0%, #5c1500 50%, #9c2800 100%)",
    desc: {
      en: "Real-time wildfire alert application for Bouches-du-Rhône. Featured on French national television.",
      fr: "Application d'alertes incendie en temps réel pour les Bouches-du-Rhône. Couverte par les médias nationaux.",
    },
  },
  {
    id: "myintra",
    name: "My Intra",
    year: "2022",
    primary: "Dart",
    tags: ["Flutter", "Firebase"],
    github: "https://github.com/adamlbs/My-Intra",
    color: "#125050",
    img: "/myintra.png",
    imgGradient:
      "linear-gradient(135deg, #041414 0%, #0a3030 50%, #125050 100%)",
    desc: {
      en: "Mobile companion app for Epitech students, aggregating intranet data into a clean interface.",
      fr: "Application mobile pour étudiants Epitech, centralisant les données de l'intranet dans une interface épurée.",
    },
  },
  {
    id: "rtype",
    name: "R-Type",
    year: "2023",
    img: "/r-type.jpg",
    github: "https://github.com/AdamLBS/R-Type",
    primary: "C++",
    tags: ["ASIO", "Networking", "ECS"],
    color: "#243060",
    imgGradient:
      "linear-gradient(135deg, #0c0e1c 0%, #141a38 50%, #243060 100%)",
    desc: {
      en: "Multiplayer remake of the classic R-Type arcade game. Uses ASIO for networking and a custom Entity Component System architecture.",
      fr: "Remake multijoueur du jeu d'arcade R-Type. Utilise ASIO pour le réseau et une architecture ECS custom.",
    },
  },
  {
    id: "zappy",
    name: "Zappy",
    year: "2022",
    github: "https://github.com/AdamLBS/zappy",
    primary: "C++",
    tags: ["C", "Python", "AI", "Networking"],
    color: "#2a4e1e",
    img: "/zappy.png",
    imgGradient:
      "linear-gradient(135deg, #0a1006 0%, #182e10 50%, #2a4e1e 100%)",
    desc: {
      en: "Epitech 2nd-year project. Multiplayer game where an AI collects resources and levels up to win. Includes a server, a graphical client, and an AI client in Python.",
      fr: "Projet de 2ème année à Epitech. Jeu multijoueur où une IA collecte des ressources et monte en niveau. Comprend un serveur, un client graphique et un client IA en Python.",
    },
  },
  {
    id: "arcade",
    name: "Arcade",
    github : "https://github.com/AdamLBS/arcade",
    year: "2022",
    primary: "C++",
    tags: ["SFML", "SDL2", "ncurses"],
    color: "#3e1860",
    img: "/arcade.png",
    imgGradient:
      "linear-gradient(135deg, #100820 0%, #280e40 50%, #3e1860 100%)",
    desc: {
      en: "Modular arcade game engine. Games and display libraries are loaded as shared objects at runtime, allowing hot-switching between renderers.",
      fr: "Moteur de jeux arcade modulaire. Jeux et bibliothèques d'affichage chargés comme bibliothèques partagées au runtime.",
    },
  },
  {
    id: "minishell",
    name: "Minishell",
    github : "https://github.com/AdamLBS/PSU-Minishell-1",
    year: "2022",
    primary: "C",
    tags: ["Unix", "POSIX"],
    stat: { en: "graded 100%", fr: "noté 100%" },
    color: "#303840",
    img: "/minishell.png",
    imgGradient:
      "linear-gradient(135deg, #141618 0%, #202428 50%, #303840 100%)",
    desc: {
      en: "POSIX-compliant shell written in C as an Epitech project. Builtins, pipes, redirections, environment variables. Graded 100%.",
      fr: "Shell compatible POSIX écrit en C dans le cadre d'un projet Epitech. Builtins, pipes, redirections, variables d'environnement. Noté 100%.",
    },
  },
  {
    id: "myrpg",
    name: "My RPG",
    github: "https://github.com/AdamLBS/my-rpg",
    year: "2021",
    primary: "C",
    tags: ["CSFML", "Game Dev"],
    color: "#243c14",
    img: "/myrpg.png",
    imgGradient:
      "linear-gradient(135deg, #0a1004 0%, #162410 50%, #243c14 100%)",
    desc: {
      en: "Top-down RPG in C using CSFML. Tile-based maps, NPC dialogues, inventory, and combat system.",
      fr: "RPG vue du dessus en C avec CSFML. Cartes en tuiles, dialogues PNJ, inventaire et combats.",
    },
  },
  {
    id: "marouviere",
    name: "Ma Rouvière",
    year: "2021",
    primary: "Java",
    tags: ["Android"],
    color: "#583018",
    img: "/marouviere.png",
    imgGradient:
      "linear-gradient(135deg, #140800 0%, #361808 50%, #583018 100%)",
    desc: {
      en: "One of my first Android apps, built in Java. Helps residents navigate the Rouvière condominium complex.",
      fr: "Une de mes premières apps Android, en Java. Aide les résidents à s'orienter dans la copropriété de la Rouvière.",
    },
  },
];

export const EXPERIENCE = [
  {
    period: "2026 →",
    company: "Wavestone",
    title: {
      en: "Cyber Security Consultant",
      fr: "Consultant Cybersécurité",
    },
    desc: {
      en: "Security consulting at Wavestone, one of Europe's leading firms in cybersecurity and digital transformation.",
      fr: "Conseil en sécurité chez Wavestone, l'un des leaders européens en cybersécurité et transformation digitale.",
    },
    tags: [],
  },
  {
    period: "2022 →",
    company: "Dealcover",
    title: {
      en: "CTO & Co-owner",
      fr: "CTO & Co-fondateur",
    },
    desc: {
      en: "Grew from intern to CTO over three and a half years. Built and scaled mobile applications reaching 170k users (Prévi+) and 25k users (FireChaser), the latter featured on French national television. Handled infrastructure end-to-end: Linux/Nginx servers, Prometheus/Grafana monitoring, Cloudflare WAF and CDN.",
      fr: "Passé de stagiaire à CTO en trois ans et demi. Développement et mise à l'échelle d'applications mobiles atteignant 170k utilisateurs (Prévi+) et 25k (FireChaser), cette dernière relayée à la télévision nationale. Infrastructure de A à Z : Linux/Nginx, monitoring Prometheus/Grafana, WAF et CDN Cloudflare.",
    },
    tags: [
      "Flutter",
      "Dart",
      "AdonisJS",
      "Firebase",
      "Docker",
      "Nginx",
      "Cloudflare",
    ],
  },
  {
    period: "2025–2026",
    company: "Dev-id",
    title: {
      en: "Software Engineer",
      fr: "Ingénieur Logiciel",
    },
    desc: {
      en: "Backend development, mobile features, and containerized infrastructure (Docker, Kubernetes). Also contributed to building Dev-ID's Cybersecurity & DevOps business unit : process assessment and security roadmap.",
      fr: "Développement backend, fonctionnalités mobiles et infrastructure conteneurisée (Docker, Kubernetes). Participation à la création de la BU Cybersécurité & DevOps de Dev-ID : évaluation des processus et feuille de route sécurité.",
    },
    tags: ["Node.js", "Flutter", "Docker", "Kubernetes"],
  },
  {
    period: "2024–2026",
    company: "LibrOpen",
    title: {
      en: "Founding Member",
      fr: "Membre Fondateur",
    },
    desc: {
      en: "Co-founded an open-source developer marketplace. Full stack ownership: GitHub Actions CI/CD, containerized AdonisJS/Node.js services, Next.js frontend, and security-by-design throughout.",
      fr: "Co-fondé une marketplace pour développeurs open-source. Stack complet : CI/CD GitHub Actions, services AdonisJS/Node.js conteneurisés, frontend Next.js, sécurité dès la conception.",
    },
    tags: ["AdonisJS", "Next.js", "Docker", "GitHub Actions", "OAuth2"],
  },
  {
    period: "2023–2024",
    company: "EPITECH",
    title: {
      en: "Regional Teaching Assistant",
      fr: "Assistant Pédagogique Régional",
    },
    desc: {
      en: "Supervised the Cybersecurity module and tutored first and second-year students at the Marseille campus.",
      fr: "Supervision du module Cybersécurité et tutorat des étudiants de première et deuxième année sur le campus de Marseille.",
    },
    tags: [],
  },
];

export const EDUCATION = [
  {
    period: "2024–2025",
    school: "University of Kent",
    degree: { en: "MSc Cyber Security", fr: "MSc Cybersécurité" },
    note: "Distinction (top 5%)",
  },
  {
    period: "2021–2026",
    school: "EPITECH",
    degree: {
      en: "Expert in Software Engineering",
      fr: "Expert en Ingénierie Logicielle",
    },
    note: "Top 3/70 Marseille · 13/800+ national",
  },
];

export const UI = {
  en: {
    nav: { home: "Home", projects: "Projects" },
    hero: {
      subtitle: "Cybersecurity consultant & developer @ Paris",
      bio: "Started writing code at 13 : Minecraft plugins, then Linux scripts, then Android apps. That instinct for building practical tools has carried through everything since: mobile apps at 170k users, encrypted messaging protocols, and security research on adversarial threat detection. Currently consulting at Wavestone, finishing a master's at Epitech.",
    },
    labels: {
      experience: "Experience",
      selectedProjects: "Selected Projects",
      allProjectsLink: "All projects →",
      research: "Research",
      education: "Education",
      contact: "Contact",
    },
    research: {
      title:
        "Evasion-Resilient Detection of DNS-over-HTTPS Data Exfiltration: A Practical Evaluation and Toolkit",
      venue: "MSc Dissertation : University of Kent · Distinction",
      desc: "Assessed how well defenders can detect DoH-based file exfiltration and which evasion strategies remain effective. Produced DoHExfTlk, a reproducible open-source toolkit, and compared machine learning against threshold-based detection under adversarial conditions.",
    },
    contact: {
      line: "Open to consulting engagements, research collaborations, and interesting problems.",
    },
    projectsPage: {
      title: "Projects",
      subtitle:
        "A mix of research tools, mobile applications, and systems programming : 2021 to present.",
    },
    ongoing: "ongoing",
    footer: "Paris",
  },
  fr: {
    nav: { home: "Accueil", projects: "Projets" },
    hero: {
      subtitle: "Consultant cybersécurité & développeur @ Paris",
      bio: "Commencé à coder à 13 ans : plugins Minecraft, scripts Linux, puis applications Android. Cette intuition pour construire des outils concrets a guidé tout ce qui a suivi : applications mobiles à 170k utilisateurs, protocoles de messagerie chiffrée, recherche sur la détection de menaces adversariales. Actuellement consultant chez Wavestone, en parallèle d'un master à Epitech.",
    },
    labels: {
      experience: "Expérience",
      selectedProjects: "Projets sélectionnés",
      allProjectsLink: "Tous les projets →",
      research: "Recherche",
      education: "Formation",
      contact: "Contact",
    },
    research: {
      title:
        "Détection résistante à l'évasion de l'exfiltration de données DNS-over-HTTPS : évaluation pratique et toolkit",
      venue: "Mémoire de master : University of Kent · Mention très bien",
      desc: "Évaluation de la capacité des défenseurs à détecter l'exfiltration de fichiers via DoH et des stratégies d'évasion efficaces. Production de DoHExfTlk, un toolkit open-source reproductible, et comparaison de l'apprentissage automatique aux approches par seuils en conditions adversariales.",
    },
    contact: {
      line: "Disponible pour des missions de conseil, des collaborations de recherche et des projets intéressants.",
    },
    projectsPage: {
      title: "Projets",
      subtitle:
        "Un mélange d'outils de recherche, d'applications mobiles et de programmation système : de 2021 à aujourd'hui.",
    },
    ongoing: "en cours",
    footer: "Paris",
  },
};
